/* eslint-disable */
import production from './appsettings.json';

const settings = production;

export default settings;
